export default {"src":"/_next/static/media/c-mail-icon.d0505bb6.svg","height":40,"width":50};